// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StarGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
		<path transform="translate(.001)" fill="url(#StarGradient_tsx__a)" d="M0 0h24v24H0z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.795 21.875a.498.498 0 0 1-.218-.05l-5.576-2.694-5.577 2.694a.5.5 0 0 1-.714-.505l.718-6.44-4.178-4.763a.5.5 0 0 1 .273-.82L8.548 8.03l3.012-5.64a.5.5 0 0 1 .882 0l3.012 5.64 6.025 1.268a.5.5 0 0 1 .273.819l-4.178 4.763.718 6.44a.5.5 0 0 1-.497.555Z"
			fill="#fff"
			fillOpacity={0.8}
		/>
		<defs>
			<linearGradient id="StarGradient_tsx__a" x1={0} y1={0} x2={24} y2={24} gradientUnits="userSpaceOnUse">
				<stop stopColor="#F39871" />
				<stop offset={1} stopColor="#F0D975" />
			</linearGradient>
		</defs>
	</svg>
);
export default StarGradient;
